<ng-container *ngIf="districtDetails$ | async as districtDetails">
  <div class="info-wrap">
    <div class="description-wrap">
      <div class="title"><span [ngStyle]="{'color': districtMap[district].color}">{{ district }}</span>&nbsp;District</div>
      <div class="line" [ngStyle]="{'border-color': districtMap[district].color}"></div>
      <div class="description">{{ districtDetails.description }}</div>
    </div>
    <div class="bottom-wrap">
      <div class="demographics-wrap">
        <img [src]="'/assets/img/game/demographics-' + districtMap[district].colorName + '.svg'">
        <div>Demographics</div>
      </div>
      <div class="stats">
        <div class="stat-wrap">
          <div class="text">{{ districtDetails.income }}</div>
          <div class="descr-wrap">
            <div class="icon-wrap">
              <img [src]="'/assets/img/game/avg-income-' + districtMap[district].colorName + '.svg'">
            </div>
            <div class="descr">Average Income</div>
          </div>
        </div>
        <div class="stat-wrap">
          <div class="text">{{ districtDetails.age }}</div>
          <div class="descr-wrap">
            <div class="icon-wrap">
              <img [src]="'/assets/img/game/age-group-' + districtMap[district].colorName + '.svg'">
            </div>
            <div class="descr">Primary Age Group</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="close-wrap" [ngStyle]="{'background-color': districtMap[district].color}">
    <img (click)="onCloseClick()" src="/assets/img/game/close-round.svg">
  </div>
  <img
    *ngIf="district === 'Retail'"
    class="district-bg"
    src="/assets/img/game/retail-district-small.svg"
    [ngStyle]="{'width': '45em', 'top': '3em', 'right': '4em'}"
  >
  <img
    *ngIf="district === 'University'"
    class="district-bg"
    src="/assets/img/game/university-district-small.svg"
    [ngStyle]="{'width': '45em', 'top': '7em', 'right': '6em'}"
  >
  <img
    *ngIf="district === 'Suburban'"
    class="district-bg"
    src="/assets/img/game/suburban-district-small.svg"
    [ngStyle]="{'width': '30em', 'top': '8em', 'right': '13em'}"
  >
  <img
    *ngIf="district === 'Industrial'"
    class="district-bg"
    src="/assets/img/game/industrial-district-small.svg"
    [ngStyle]="{'width': '50em', 'top': '9em', 'right': '7em'}"
  >
  <img
    *ngIf="district === 'Shopping Centre'"
    class="district-bg"
    src="/assets/img/game/shopping-centre-district-small.svg"
    [ngStyle]="{'width': '45em', 'top': '10em', 'right': '6em'}"
  >
</ng-container>